<template>
  <b-modal v-model="isModalOpen">
    <validation-observer v-slot="{ handleSubmit, meta: { valid } }">
      <ld-modal-content :title="patient.display_name ? `Edit Patient: ${$helpers.mask('patient_name', patient.display_name)}` : 'Edit Patient'">
        <template #default>
          <input-with-validation field-label="Virtual Patient Status" v-model="patient.patient_status_id">
              <template #custom>
              <div>
                  <b-select placeholder="Select Status" expanded v-model="patient.patient_status_id">
                  <option value="">N/A</option>
                  <option v-for="status in patientStatusValues" :key="status.id" :value="status.id">
                      {{ status.label }}
                  </option>
                  </b-select>
              </div>
              </template>
          </input-with-validation>
        </template>
        <template #footer>
          <div class="action-buttons is-flex is-justify-content-center mt-0">
            <button class="button" @click="closeModal">Cancel</button>
            <button class="button is-success" :disabled="!valid" @click="handleSubmit(savePatient)">Save</button>
          </div>
        </template>
      </ld-modal-content>
    </validation-observer>
  </b-modal>  
</template>

<script>
import to from '@/lib/to'
import LdModalContent from '@/components/LdModalContent'
import InputWithValidation from '@/components/validation/InputWithValidation'
import { EventBus, EVENTS } from '@/lib/EventBus';

export default {
  name: 'PatientQuickEditModal',
  components: {
    LdModalContent,
    InputWithValidation
  },
  data() {
    return {
      isModalOpen: false,
      patientId: null,
      patient: {
        id: null,
        patient_status_id: null
      },
      patientStatusValues: []
    }
  },
  methods: {
    async fetchPatientData() {
      this.patient = { id: null, patient_status_id: null }
      
      const requests = [
        this.$http.get('/dynamic_fields', { params: { table_name: 'patients', field_name: 'status' } }),
        this.$http.get(`/patients/${this.patientId}`)
      ]
      
      const [err, response] = await to(Promise.all(requests))
      
      if (!err) {
        const [{ data: dynamicFieldsResponse }, { data: patientData }] = response
        
        if (dynamicFieldsResponse && dynamicFieldsResponse.length > 0) {
          this.patientStatusValues = dynamicFieldsResponse[0].values
            .filter(val => val.is_enabled)
            .sort((a, b) => a.sort_order - b.sort_order)
        }
        
        this.patient = {
          id: patientData.id,
          patient_status_id: patientData.patient_status_id,
          display_name: patientData.display_name
        }
      }
    },
    async savePatient() {
      const [err] = await to(this.$http.put(`/patients/${this.patientId}`, {
        patient_status_id: this.patient.patient_status_id
      }, { handleErrors: true }))
      
      if (!err) {
        this.$buefy.toast.open({
          message: 'Patient status updated successfully',
          type: 'is-success',
          duration: 3000
        })
        EventBus.$emit(EVENTS.PATIENT_UPDATED, this.patientId)
        this.closeModal()
      }
    },
    openModal(patientId) {
      this.patientId = patientId
      this.isModalOpen = true
      this.fetchPatientData()
    },
    closeModal() {
      this.isModalOpen = false
    }
  }
}
</script>

<style scoped lang="scss">
.modal-card {
  width: 500px;
}
</style> 